import { assertNotEmpty } from '@festina-life/core'
import { useEffect, useRef } from 'react'

/** Creates a MutationObserver over any Element, firing the Mutation callback function provided as an input param whenever
 * a change occurs in the DOM.
 */
export const useMutationObserver = <T extends Element>(
  onUpdate: MutationCallback,
) => {
  const elementRef = useRef<T>(null)
  const observerCallback = useRef(onUpdate)

  useEffect(() => {
    // Component may not have been mounted yet (e.g. under a disclosure)
    // If that happens, consider moving the hook use to the inner child.
    assertNotEmpty(elementRef.current)

    const observer = new MutationObserver(observerCallback.current)
    observer.observe(elementRef.current, { subtree: true, childList: true })

    return () => observer.disconnect()
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [observerCallback])

  return elementRef
}
